export enum PrivilegeEnum {
    AMELIORATION_CONTINUE = 'AMELIORATION_CONTINUE',
    RESSOURCE_HUMAINE = 'RESSOURCE_HUMAINE',
    CONTROLE_ACCES = 'CONTROLE_ACCES',
    GESTION_DOCUMENTAIRE = 'GESTION_DOCUMENTAIRE',
    INDICATEUR = 'INDICATEUR',
    PARAMETRER_APP = 'PARAMETRER_APP',
    AMELIORATION_CONTINUE_NON_CONFORMITE = 'AMELIORATION_CONTINUE_NON_CONFORMITE',
    AMELIORATION_CONTINUE_RECLAMATION = 'AMELIORATION_CONTINUE_RECLAMATION',
    AMELIORATION_CONTINUE_ACTION = 'AMELIORATION_CONTINUE_ACTION',
    AMELIORATION_CONTINUE_BILAN_ANALYSE = 'AMELIORATION_CONTINUE_BILAN_ANALYSE',
    AMELIORATION_CONTINUE_ENQUETTE_SATISFACTION = 'AMELIORATION_CONTINUE_ENQUETTE_SATISFACTION',
    RESSOURCE_HUMAINE_EMPLOYE = 'RESSOURCE_HUMAINE_EMPLOYE',
    RESSOURCE_HUMAINE_FICHE_POSTE = 'RESSOURCE_HUMAINE_FICHE_POSTE',
    RESSOURCE_HUMAINE_QUESTIONNAIRE = 'RESSOURCE_HUMAINE_QUESTIONNAIRE',
    PARAMETRER_APP_GENERAL = 'PARAMETRER_APP_GENERAL',
    PARAMETRER_APP_AMELIORATION_CONTINUE = 'PARAMETRER_APP_AMELIORATION_CONTINUE',
    PARAMETRER_APP_RESSOURCE_HUMAINE = 'PARAMETRER_APP_RESSOURCE_HUMAINE',
    PARAMETRER_APP_RESSOURCE_HUMAINE_ETUDE_UNIVERSITAIRE = 'PARAMETRER_APP_RESSOURCE_HUMAINE_ETUDE_UNIVERSITAIRE',
    PARAMETRER_APP_RESSOURCE_HUMAINE_COMPETENCE = 'PARAMETRER_APP_RESSOURCE_HUMAINE_COMPETENCE',
    PARAMETRER_APP_RESSOURCE_HUMAINE_SERVICE = 'PARAMETRER_APP_RESSOURCE_HUMAINE_SERVICE',
    PARAMETRER_APP_RESSOURCE_HUMAINE_VACCINATION = 'PARAMETRER_APP_RESSOURCE_HUMAINE_VACCINATION',
    GMAO = 'GMAO',
    GMAO_EQUIPEMENT = 'GMAO_EQUIPEMENT',
    GMAO_PANNE = 'GMAO_PANNE',
    GMAO_INTERVENTION = 'GMAO_INTERVENTION',
    GMAO_TACHE = 'GMAO_TACHE',
    GMAO_PIECE = 'GMAO_PIECE',
    RISQUE = 'RISQUE',
    REVUE_DIRECTION = 'REVUE_DIRECTION',
    AUDIT = 'AUDIT',
    PARAMETRER_APP_GMAO = 'PARAMETRER_APP_GMAO',
    PARAMETRER_APP_RISQUE = 'PARAMETRER_APP_RISQUE',
    PARAMETRER_APP_GED = 'PARAMETRER_APP_GED',
    PARAMETRER_APP_AUDIT = 'PARAMETRER_APP_AUDIT',
    AMELIORATION_CONTINUE_CALENDRIER = 'AMELIORATION_CONTINUE_CALENDRIER',
    PARAMETRER_APP_REVUE_DIRECTION = 'PARAMETRER_APP_REVUE_DIRECTION',
    STOCK = 'STOCK',
    STOCK_ARTICLE = 'STOCK_ARTICLE',
    STOCK_BON = 'STOCK_BON',
    STOCK_INVENTAIRE = 'STOCK_INVENTAIRE',
    STOCK_FACTURE = 'STOCK_FACTURE',
    STOCK_REGLEMENT = 'STOCK_REGLEMENT',
    STOCK_SITUATION_FOURNISSEUR = 'STOCK_SITUATION_FOURNISSEUR',
    STOCK_CAISSE = 'STOCK_CAISSE',
    PARAMETRER_APP_STOCK = 'PARAMETRER_APP_STOCK',
    STOCK_LOT_STOCK = 'STOCK_LOT_STOCK',
	DOCUMENTATION = 'DOCUMENTATION',
    COMPAGNE = 'COMPAGNE',
    FEEDBACK = 'FEEDBACK',
    RATING = 'RATING',
    TODO = 'TODO',
    PARAMETRER_APP_EVALUATION_FOURNISSEUR = "PARAMETRER_APP_EVALUATION_FOURNISSEUR",
    EVAL_CATEGORIE_FOURNISSEUR = "EVAL_CATEGORIE_FOURNISSEUR",
    EVAL_EVALUATION_CATEGORIE_FOURNISSEUR = "EVAL_EVALUATION_CATEGORIE_FOURNISSEUR",
    EVAL = "EVAL",
}